<template>
  <el-container>
    <el-aside width="initial">
      <h1 class="logo" :class="{ 'logo-collapse': isCollapse }">
        <span>east.net</span>
      </h1>
      <div class="scroll-container" :style="{ height: asideHeight }">
        <el-menu
          :default-active="$route.path"
          active-text-color="#1f8fff"
          :collapse="isCollapse"
          router
        >
          <template v-for="(item, index) in menus">
            <el-submenu
              :index="index.toString()"
              v-if="item.children && item.children.length > 1"
              :key="item.path"
            >
              <template slot="title">
                <i :class="item.meta.icon"></i>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item
                v-for="c in item.children.filter(p => p.meta && p.meta.menu)"
                :index="c.path"
                :key="c.path"
              >
                <ruby></ruby>
                {{ c.name }}
              </el-menu-item>
            </el-submenu>
            <el-menu-item :index="item.path" v-else :key="item.path">
              <i :class="item.meta.icon"></i>
              <span>{{ item.name }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </el-aside>
    <el-container>
      <el-header class="header-box" height="50px">
        <i class="el-icon-menu switch" @click="handleCollapse"></i>
        {{ name }}
        <ul class="navbar-right">
          <li>
            <i class="el-icon-user-solid"></i>
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ this.$store.getters.name }}
                <i class="el-icon-caret-bottom"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-lock" command="cpwd">修改密码</el-dropdown-item>
                <el-dropdown-item icon="el-icon-switch-button" command="logout">退出系统</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li>
            <i class="el-icon-refresh-right" title="重启服务" @click="handleRestart"></i>
          </li>
          <li>
            <el-badge is-dot>
              <i class="el-icon-message-solid"></i>
            </el-badge>
          </li>
          <li>
            <i class="el-icon-search"></i>
          </li>
        </ul>
        <!-- 修改密码 start-->
        <east-cpwd :show="isShow" @hide="handleHide"></east-cpwd>
        <!-- 修改密码 end -->
      </el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          v-for="item in breadcrumb"
          :to="item.redirect || item.path"
          :key="item.path"
        >{{ item.name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-main :style="{ height: mainHeight }">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import { deleteToken } from "../api/main/api-user";
import { putHost } from "../api/main/api-host";
import { backend } from "@/router";
export default {
  data() {
    return {
      name: "北京东方网景网络技术有限公司",
      isCollapse: window.localStorage.getItem("menu_collapse") === "true",
      asideHeight: window.innerHeight - 50 + "px",
      mainHeight: window.innerHeight - 90 + "px",
      menus: [],
      breadcrumb: [],
      isShow: false
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   if (store.getters.commonuser) {
  //     next("/");
  //   } else {
  //     next();
  //   }
  // },
  components: { "east-cpwd": () => import("@/pages/main/components/cpwd") },
  created() {
    this.menus = backend[0].children.filter(p => p.meta && p.meta.menu);
  },
  mounted() {
    window.addEventListener("resize", () => this.measure(), false);
    this.getBreadcrumb();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.measure(), false);
  },
  watch: {
    $route(to, from) {
      this.getBreadcrumb();
    }
  },
  methods: {
    measure() {
      this.asideHeight = window.innerHeight - 50 + "px";
      this.mainHeight = window.innerHeight - 90 + "px";
    },
    getBreadcrumb() {
      this.breadcrumb = this.$route.matched.filter(p => p.path !== "");
    },
    handleCollapse() {
      this.isCollapse = !this.isCollapse;
      window.localStorage.setItem("menu_collapse", this.isCollapse);
    },
    handleRestart() {
      this.$confirm("是否确定重启系统服务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false
      })
        .then(() => {
          // 重启服务
          putHost().then(res => {
            if (res.code === 0) {
              this.$notify.success({
                title: "成功",
                message: "成功重启系统服务",
                duration: 1500
              });
            } else {
              this.$notify.error({
                title: "失败",
                message: "重启系统服务失败",
                duration: 1500
              });
            }
          });
        })
        .catch(() => {});
    },
    handleCommand(command) {
      if (command === "cpwd") {
        this.isShow = true;
      } else if (command === "logout") {
        // 注销token
        this.$confirm("是否确认退出系统?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        })
          .then(() => {
            deleteToken().then(res => {
              if (res.code === 0) {
                this.$store.dispatch("logoutAction");
                this.$notify.success({
                  title: "成功",
                  message: "成功退出系统",
                  duration: 500,
                  onClose: () => {
                    this.$router.replace("/login");
                  }
                });
              } else {
                this.$notify.error({
                  title: "失败",
                  message: res.msg
                });
              }
            });
          })
          .catch(() => {});
      }
    },
    handleHide() {
      this.isShow = false;
    }
  }
};
</script>
<style lang="less" >
@topFc: #ffffff;
@topBc: #006edb;
@topBcTrans: #0e82f5;
@topSpacer: #0354a5;

@asideFc: #3c3e52;
@asideBc: #ffffff;
@scrollBRc: #e7e6e6;
@asideAc: #1f8fff;
@asideABc: #f9fbfd;
.ruby {
  ruby {
    display: inline-block;
    width: 6px;
    height: 6px;
    margin-right: 7px;
    border-radius: 50%;
    background-color: @asideFc;
  }
}
// 左侧导航区
.el-aside {
  background-color: @asideBc;
  text-align: left;
  .logo {
    display: block;
    height: 50px;
    line-height: 50px;
    padding: 0px;
    margin: 0px;
    background: url("../assets/logo-icon.png") 22px 18px no-repeat @topBc;
    color: #ffffff;
    font-size: 22px;
    font-weight: normal;
    font-family: Arial, Helvetica, sans-serif;
    text-indent: 60px;
  }
  .logo-collapse {
    span {
      display: none;
    }
  }
  .scroll-container {
    border-right: 1px solid @scrollBRc;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
.el-menu {
  border: none;
  color: @asideFc;
  background-color: @asideBc;
  &:not(.el-menu--collapse) {
    width: 180px;
    *:not(i) {
      font-size: 13px;
    }
  }
  .el-menu-item,
  .el-submenu {
    border-left: @asideBc 2px solid;
  }
  .el-menu-item,
  .el-submenu__title {
    color: @asideFc;
    background-color: @asideBc;
    &:hover {
      color: @asideAc;
      i {
        color: @asideAc;
      }
      ruby {
        background-color: @asideAc;
      }
    }
  }
  .is-active {
    border-left: @asideAc 2px solid;
    background-color: @asideABc;
    i,
    span {
      color: @asideAc;
    }
    .el-submenu__title,
    ul.el-menu--inline li {
      background-color: @asideABc;
      &.is-active {
        margin-top: 0px;
        ruby {
          background-color: @asideAc;
        }
      }
    }
  }
}
.el-menu--collapse {
  width: 68px;
  .el-menu-item i,
  .el-submenu i {
    font-size: 24px;
  }
}

.el-menu--popup {
  width: auto !important;
  min-width: 150px !important;
  margin-left: 0px;
  border-radius: 0 3px 3px 0;
  .el-menu-item {
    border-left: none;
    padding-left: 20px !important;
    height: 36px;
    line-height: 36px;
    .ruby();
  }
  li.is-active {
    ruby {
      background-color: @asideAc;
    }
  }
}
.el-menu--inline {
  width: auto !important;
  .el-menu-item {
    border-left: none;
    padding-left: 40px !important;
    height: 36px;
    line-height: 36px;
    .ruby();
  }
}

.header-box {
  background-color: @topBc;
  background-image: linear-gradient(to right, @topBc 0%, @topBcTrans 100%);
  background-repeat: repeat-x;
  color: @topFc;
  text-align: left;
  line-height: 50px;
  font-size: 13px;
  padding: 0px 5px;
  overflow: hidden;
  i {
    cursor: pointer;
    font-size: 16px;
    &.switch {
      position: relative;
      font-size: 16px;
      top: 1px;
      cursor: pointer;
    }
  }

  ul.navbar-right {
    float: right;
    padding-right: 10px;
    line-height: 20px;
    li {
      float: right;
      margin-left: 15px;
      list-style: none;
      font-size: 13px;
      .el-dropdown-link {
        color: #ffffff;
        cursor: pointer;
        font-size: 13px;
      }
      &:first-child::before {
        content: "|";
        color: @topSpacer;
        padding-right: 10px;
      }
    }
  }
}
.el-dropdown-menu .el-dropdown-menu__item {
  font-size: 13px;
}
.el-breadcrumb {
  z-index: 10;
  box-shadow: 0 0px 3px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  border-bottom: 1px solid @scrollBRc;
  color: #333333;
  text-align: left;
  padding: 0px 10px;
  height: 39px;
  line-height: 39px;
  font-size: 13px;
}
.el-main {
  padding: 2px;
  background-color: #fffefe;
  font-size: 13px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin.vue